import gql from 'graphql-tag'

export const TagCountQuery = gql`
  query TagCount($categoryId: String!, $value: String!) {
    tagCount(categoryId: $categoryId, value: $value) {
      count
    }
  }
`
